import { Injectable } from '@angular/core';
import { BaseRepository, HttpCancelableRequest } from '../../Common/Data/base.repository';
import { Observable } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class AttachmentBundlerRepository extends BaseRepository {
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    baseRoute: string = 'api/attachmentBundler';

    getList(search: Core.AttachmentBundlerSearchModel): HttpCancelableRequest<Core.AttachmentBundlerItemModel[]> {
        return this.httpPostWithCancel(`${this.baseRoute}/getList`, search);
    }

    bundle(search: Core.AttachmentBundlerGenerateFile): Observable<void> {
        return this.httpPost(`${this.baseRoute}/generateFile`, search);
    }

    downloadBundle(fileId: number): Observable<HttpResponse<Blob>> {
        const options = {
            observe: 'response',
            responseType: 'blob',
        };
        return this.httpGet(`${this.baseRoute}/generatedFile/${fileId}`, options);
    }
}
